import { Controller } from "@hotwired/stimulus";

/** Live preview for avatar image + ring colors (Account Settings). */
export default class extends Controller {
  static targets = ["ring", "image"];
  static values = { urls: Object };

  connect() {
    this.sync();
  }

  sync() {
    const form = this.element.tagName === "FORM" ? this.element : this.element.closest("form");
    if (!form || !this.hasRingTarget || !this.hasImageTarget) return;

    const avatarEl = form.querySelector('[name="user[avatar]"]');
    const primaryEl = form.querySelector('[name="user[primary_color]"]');
    const borderEl = form.querySelector('[name="user[border_color]"]');

    const slug = avatarEl?.value;
    if (slug && this.urlsValue && this.urlsValue[slug]) {
      this.imageTarget.src = this.urlsValue[slug];
    }

    if (primaryEl?.value) this.ringTarget.style.backgroundColor = primaryEl.value;
    if (borderEl?.value) this.ringTarget.style.setProperty("--tw-ring-color", borderEl.value);
  }
}
